const truncateString = (str, maxLength, separator = '...') => {
  if (str.length <= maxLength) {
    return str;
  }
  const separatorLength = separator.length;
  const parts = str.split(separator);
  let lastPart = parts.pop();
  const firstPart = parts.join(separator);

  if (firstPart.length + lastPart.length + separatorLength <= maxLength) {
    return firstPart + separator + lastPart;
  }

  while (separator.length + lastPart.length > maxLength) {
    lastPart = lastPart.slice(0, -1);
  }

  return firstPart + separator + lastPart;
}

export default truncateString